// eslint-disable-next-line import/prefer-default-export
export const BLUEPRINT_RELEASE_SOURCE_TYPE__PROJECT_JSON = 'project.json';
